module.exports = __webpack_public_path__ + "img/Unidad22-3.e70cc262.png";